export default __webpack_public_path__ + "static/media/hipercard.e79080a0.svg";